import { useMemo } from "react"

export default (goods) => {
  const products = useMemo(() => {
    return goods?.products?.sort((a, b) => Number(a.money) - Number(b.money)).map((item, i) => {
      // 货币单位优先取接口返回的币种字段，缺省回退到 USD（premium 商品无该字段时保持原逻辑）
      const unit = item.currency || "USD"
      const rebate = Number(item.sale_off)
      // 首充赠送比例(百分比字符串，如 "10" 表示首充额外赠送 10%)，0 或缺省表示无首充活动
      const firstRechargeRate = Number(item.extra?.first_recharge_reward_rate) || 0
      let month = 1
      switch (item.billingPeriod) {
        case 'SEASONLY':
          month = 3
          break
        case 'HALF-YEARLY':
          month = 6
          break
        case 'YEARLY':
          month = 12
          break
      }

      return {
        id: item.goods_id,
        title: item.title,
        billingPeriod: item.billingPeriod,
        pricing: item.money,
        // sale_off 为 0 或 1 都表示无折扣，不显示折扣 tag
        rebate: (rebate === 1 || rebate === 0) ? null : 1 - rebate,
        desc: (rebate === 1 || rebate === 0) ? null : `Only: ${unit}${(item.money / month).toFixed(2)}/Month`,
        unit,
        // 首充赠送：比例(0-1)与按到账数量(billingPeriod)折算出的赠送数量
        firstRechargeRate: firstRechargeRate ? firstRechargeRate / 100 : null,
        firstRechargeReward: firstRechargeRate ? Math.floor(Number(item.billingPeriod) * firstRechargeRate / 100) : null
      }
    }) || []
  }, [goods.products])

  return products
}